<template>
  <div class="introForm">
    <Card :_expand="true">
      <template v-slot:title>
        Post Writer
        <span class="--text-md"> Virtual Assistant </span>
      </template>

      <template v-slot:content>
        <ul>
          <li>
            Designed to help the "Post Writer Pro" team write and deliver amazing posts.
          </li>
          <li>
            Useful Instructions:
            <a href="#"> How to write a Post Course</a>,
            <a href="#"> How to use the "Post Writer VA" tool</a>
          </li>
          <li>
            View Examples:
            <a href="#">Question Post 1</a>, <a href="#">Question Post 2</a>,
            <a href="#">List Post 1</a>
            and
            <a href="#">List Post 2</a> .
          </li>
          <li>
            Load Template:
            <a href="#" @click="loadTemplate('question')">Question Post</a>,
            <a href="#" @click="loadTemplate('list')">List Post</a>
          </li>
        </ul>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";

export default {
  name: "Banner",
  components: { Card },
  emits: ["templateChange"],
  methods: {
    loadTemplate(template) {
      this.$emit("templateChange", template);
    },
  },
};
</script>

<style scoped lang="scss"></style>
